var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayConditionOk
    ? _c("div", { staticClass: "form-group row orezo-file-input text-left" }, [
        _c("label", { staticClass: "col-12 col-form-label text-left" }, [
          _vm._v(_vm._s(_vm.label))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12",
            class: {
              "drag-active":
                _vm.$refs.fileInput && _vm.$refs.fileInput.dropActive
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.serializedValue,
                  expression: "serializedValue"
                }
              ],
              attrs: {
                type: "hidden",
                name: _vm.name,
                "data-serialized": "true",
                required: _vm.required
              },
              domProps: { value: _vm.serializedValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.serializedValue = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            !_vm.readonly
              ? _c(
                  "file-upload",
                  {
                    ref: "fileInput",
                    attrs: {
                      name: _vm.name + "_upload",
                      drop: true,
                      "auto-upload": true,
                      data: _vm.internalData,
                      "chunk-enabled": true,
                      chunk: _vm.getChunkOptions(),
                      multiple: _vm.multiple,
                      "post-action": _vm.currentPostAction
                    },
                    on: { input: _vm.onUploadInput },
                    model: {
                      value: _vm.inputFiles,
                      callback: function($$v) {
                        _vm.inputFiles = $$v
                      },
                      expression: "inputFiles"
                    }
                  },
                  [
                    !_vm.readonly
                      ? _c("div", { staticClass: "input-group" }, [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: " input-group-text" }, [
                              _c("i", { staticClass: "fa fa-file-o" })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "form-control" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  "Choisissez ou glissez-déposez un" +
                                    (_vm.multiple
                                      ? " ou plusieurs fichiers"
                                      : " fichier")
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group-append" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v("Parcourir")
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.readonly && _vm.files.length === 0
              ? _c("em", [_vm._v("Aucun fichier")])
              : _vm._e(),
            _vm._v(" "),
            _vm.files.length + _vm.inputFiles.length > 0
              ? _c(
                  "ul",
                  { staticClass: "list-group mt-1" },
                  [
                    _vm._l(_vm.files, function(file) {
                      return _c(
                        "li",
                        {
                          staticClass:
                            "list-group-item d-flex justify-content-between align-items-center p-1 px-2 ",
                          class: [{ deleted: file.deleted == true }]
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "mr-auto",
                              attrs: {
                                href: _vm.getPreviewUrl(file.publicId),
                                "data-toggle": "modal",
                                "data-target": "#modal",
                                "data-size": "xl"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-fw",
                                class: _vm.getFileExtensionCss(file.fileName),
                                attrs: {
                                  title: _vm.getFileExtension(file.fileName)
                                }
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(file.fileName) +
                                  "\n                        "
                              ),
                              file.deleted == true
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "ml-1 mb-0 font-weight-bold"
                                    },
                                    [_c("em", [_vm._v("(supprimé)")])]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("em", { staticClass: "text-secondary" }, [
                            _vm._v(_vm._s(_vm.getFileTypeLabel(file.fileType)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-block text-secondary mr-2 text-right",
                              staticStyle: {
                                "font-size": "0.8rem",
                                width: "5rem"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm._f("file-size")(file.fileSize)) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "badge badge-pill",
                              class: { invisible: file.deleted },
                              attrs: { href: _vm.getUrl(file.publicId) }
                            },
                            [_c("i", { staticClass: "fa fa-fw fa-download" })]
                          ),
                          _vm._v(" "),
                          _vm.candelete && !_vm.readonly
                            ? _c(
                                "a",
                                {
                                  staticClass: "badge badge-primary badge-pill",
                                  attrs: {
                                    href: "#1",
                                    title: file.deleted
                                      ? "Ne pas supprimer"
                                      : "Supprimer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteFile(file)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-fw",
                                    class: {
                                      "fa-trash": !file.deleted,
                                      "fa-recycle": file.deleted
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.inputFiles, function(file) {
                      return _c(
                        "li",
                        {
                          staticClass:
                            "list-group-item d-flex justify-content-between align-items-center p-1 px-2 bg-light",
                          class: { "text-danger": file.__invalid }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-fw mr-1",
                            class: _vm.getFileExtensionCss(file.name),
                            attrs: { title: _vm.getFileExtension(file.name) }
                          }),
                          _vm._v(" "),
                          !_vm.readonly && !file.__invalid
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "badge badge-primary badge-pill mr-1",
                                  attrs: { href: "#2", title: "Renommer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeName(file)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-fw fa-pencil-square-o"
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !file.editing
                            ? _c(
                                "span",
                                { staticClass: "mr-auto w-100 mr-1" },
                                [_vm._v(_vm._s(file.name))]
                              )
                            : _c("file-name-editor", {
                                model: {
                                  value: file.name,
                                  callback: function($$v) {
                                    _vm.$set(file, "name", $$v)
                                  },
                                  expression: "file.name"
                                }
                              }),
                          _vm._v(" "),
                          file.__invalid
                            ? [
                                _c("small", { staticClass: "mx-2 w-50" }, [
                                  _c("i", {
                                    staticClass: "fa fa-fw fa-warning"
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(file.__message) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            : [
                                _vm._m(0, true),
                                _vm._v(" "),
                                file.progress > 0 &&
                                (file.progress < 100 ||
                                  (file.progress == 100 && !file.success))
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "progress w-50 position-relative"
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "progress-bar",
                                            style:
                                              "width: " + file.progress + "%",
                                            attrs: {
                                              role: "progressbar",
                                              "aria-valuenow": file.progress,
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-100 position-absolute w-100 text-center"
                                            },
                                            [
                                              file.__validating
                                                ? [
                                                    _vm._v(
                                                      "\n                                        Validation en cours\n                                    "
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                        Envoi en cours\n                                    "
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        { staticClass: "d-inline-block ml-2" },
                                        [
                                          _vm.allowedFileTypes &&
                                          _vm.allowedFileTypes.length > 0
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: file.fileType,
                                                      expression:
                                                        "file.fileType"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control p-0",
                                                  class: {
                                                    "is-invalid":
                                                      file.fileType == 0 ||
                                                      file.fileType == ""
                                                  },
                                                  staticStyle: {
                                                    width: "auto",
                                                    height: "unset"
                                                  },
                                                  attrs: {
                                                    required: "",
                                                    title: "Type du fichier"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        file,
                                                        "fileType",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: 0,
                                                        selected:
                                                          file.fileType == 0
                                                      }
                                                    },
                                                    [_vm._v(" — ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.allowedFileTypes,
                                                    function(typeId) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          domProps: {
                                                            value: typeId,
                                                            selected:
                                                              file.fileType ==
                                                              typeId
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm.getFileTypeLabel(
                                                                  typeId
                                                                )
                                                              ) +
                                                              "\n                                    "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.docWillReplace(file)
                                            ? _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "mx-2 text-danger d-block"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-fw fa-warning"
                                                  }),
                                                  _vm._v(
                                                    "\n                                    Ce document remplacera le document existant\n                                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                              ],
                          _vm._v(" "),
                          _c(
                            "small",
                            {
                              staticClass:
                                "d-block text-secondary mr-2 text-right",
                              staticStyle: { width: "6rem" }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm._f("file-size")(file.size)) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.readonly
                            ? _c(
                                "a",
                                {
                                  staticClass: "badge badge-primary badge-pill",
                                  attrs: {
                                    href: "#1",
                                    title: "Ne pas envoyer"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteFile(file)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-fw fa-trash" })]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", { staticClass: "mx-2 text-success" }, [
      _c("i", { staticClass: "fa fa-fw fa-check" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6504eb46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6504eb46","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/UploadFile.vue
// module id = 544
// module chunks = 0